module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-lock2-fill-e03d7df6.svg";